import angular = require("angular");
import { utilsModule } from "../../utils-module";

function passwordInputController() {
    var ctrl = this;
    var self = this;    

    ctrl.MIN_PASSWORD_SIZE = 6;

    ctrl.$onInit = function () {
        console.log(ctrl.showErrorMessages);
        if (ctrl.showErrorMessages === undefined) {
            // ctrl.showErrorMessages = true;
        }
    }
}
utilsModule.component('passwordInput', {
    template: require('./password-input.component.html'),
    controller: [passwordInputController],
    bindings: {
        password: '=',
        form: '=',
        showErrorMessages: '=',
        textWhite: "="
    }
});
utilsModule.directive('idhaPassword', function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, elem, attr, ctrl: any) {
            var MIN_PASSWORD_SIZE = 6;

            var isEmpty = function (value) {
                return angular.isUndefined(value) || value === "" || value === null;
            }

            var minValidator = function (password) {
                if (!isEmpty(password)) {
                    // password must contain only letters, numbers, underscores and symbols!
                    var re = /^(\w|[@#$%&*=+-])+$/;
                    if (!re.test(password)) {
                        ctrl.$setValidity('invalidChar', false);
                    } else {
                        ctrl.$setValidity('invalidChar', true);
                    }

                    // passowrd cannont be equals to the username or email
                    /*if(password == ctrl.usernameToCheck){
                        ctrl.form.$invalid = true;
                        ctrl.form.$valid = false;
                        ctrl.form.inpPassword.$error.equalsUsernameOrEmail = true;
                    }
                    if(password == ctrl.emailToCheck){
                        ctrl.form.$invalid = true;
                        ctrl.form.$valid = false;
                        ctrl.form.inpPassword.$error.equalsUsernameOrEmail = true;
                    } */

                    // password must contain at least one number (0-9)
                    re = /[0-9]/;
                    if (!re.test(password)) {
                        ctrl.$setValidity('mustContainNumber', false);
                    } else {
                        ctrl.$setValidity('mustContainNumber', true);
                    }

                    // password must contain at least one lowercase letter (a-z)
                    re = /[a-z]/;
                    if (!re.test(password)) {
                        ctrl.$setValidity('mustContainLowerCase', false);
                    } else {
                        ctrl.$setValidity('mustContainLowerCase', true);
                    }

                    //password must contain at least one uppercase letter (A-Z)
                    re = /[A-Z]/;
                    if (!re.test(password)) {
                        ctrl.$setValidity('mustContainUpperCase', false);
                    } else {
                        ctrl.$setValidity('mustContainUpperCase', true);
                    }

                    if (password.length < MIN_PASSWORD_SIZE) {
                        ctrl.$setValidity('minLength', false);
                    } else {
                        ctrl.$setValidity('minLength', true);
                    }
                }

                return password;
            };

            ctrl.$parsers.push(minValidator);
            ctrl.$formatters.push(minValidator);
        }
    };
});